exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-78e17698]{display:flex;flex-direction:column;justify-content:space-around}.dialog_text[data-v-78e17698],.dialog_title[data-v-78e17698]{display:flex;justify-content:center}.dialog_buttons[data-v-78e17698]{display:flex;justify-content:space-between}", ""]);

// exports
